import { constantsTypes } from '../reduxConstants';

const initialState = {
  showSuperTicket: 0,
};

export const superticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case constantsTypes.VIEW_MODE_SUPTERTICKET:
      return {
        ...state,  
        showSuperTicket: action.value,  
      };
    default:
      return state;
  }
};
